exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-wrap-16vzi6yw {\n  display: flex;\n  align-items: center;\n  overflow: scroll;\n  overflow-x: hidden;\n}\n\n.styles-wrap-16vzi6yw::-webkit-scrollbar {\n  display: none;\n  scrollbar-width: none;\n}\n\n.styles-stepIndicatorWrapper-2ATwra4K {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n}\n\n.styles-stepIndicator-1GT_QtLH {\n  justify-content: center;\n  position: relative;\n  bottom: 0px;\n}\n\n.styles-carouselItemWrapper-2QgHvF1N {\n  display: flex;\n}\n", ""]);

// exports
exports.locals = {
	"wrap": "styles-wrap-16vzi6yw",
	"stepIndicatorWrapper": "styles-stepIndicatorWrapper-2ATwra4K",
	"stepIndicator": "styles-stepIndicator-1GT_QtLH",
	"carouselItemWrapper": "styles-carouselItemWrapper-2QgHvF1N"
};